import React from "react";
import DesignerHeader from "components/designerHeader";
import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DesignerSidebar from "components/desingerSidebar";
import DesignerFooter from "components/designerFooter";
import {
  calendarEditIcon,
  calendarIcon,
  closeIcon,
  courseListSecondaryIcon,
  deleteIcon,
  editBlueIcon,
  editGreenIcon,
  editIcon,
  editPurpleIcon,
  editWhiteIcon,
  editYellowIcon,
  listCheckIcon,
  personEditIcon,
  saveIcon,
} from "assets/images";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Link } from "react-router-dom";

function CalendarIcon() {
  return (
    <div className="calendar-icon">
      <img src={calendarIcon} alt="calendar" />
    </div>
  );
}

type TimelineItem = {
  id: string;
  title: string;
  description: string;
  author: string;
  date: string;
};

const timelineData: TimelineItem[] = [
  {
    id: "enrolled-2022-11-03",
    title: "Student Enrolled",
    description: "Student successfully enrolled in the program.",
    author: "Rachael Rogan",
    date: "03 Nov 2022 10:00am",
  },
  {
    id: "allocated-pla-2022-11-03",
    title: "Allocated PLA",
    description:
      "Peer Learning Advisor (PLA) has been allocated to the student.",
    author: "Rachael Rogan",
    date: "03 Nov 2022 10:00am",
  },
  {
    id: "deferred-slp-2022-11-03",
    title: "Deferred SLP",
    description: "Student's SLP has been deferred.",
    author: "Rachael Rogan",
    date: "03 Nov 2022 10:00am",
  },
  {
    id: "contact-progress-2022-11-03",
    title: "Updated Contact Progress",
    description: "Contact progress has been updated to In-Progress",
    author: "Rachael Rogan",
    date: "03 Nov 2022 10:00am",
  },
  {
    id: "slp-participation-2022-11-03",
    title: "Updated SLP Participation",
    description:
      "SLP participation status has been updated to No further SLP Required",
    author: "Rachael Rogan",
    date: "03 Nov 2022 10:00am",
  },
];

const DesignerStudentProfileDetails: React.FC = () => {
  // Allocate PLA Modal State
  const [reset, setReset] = React.useState(false);
  const handleReset = () => setReset(true);
  const handleResetClose = () => setReset(false);

  // Select1 State
  const [select1, setSelect1] = React.useState("");
  const handleSelect1Change = (event: SelectChangeEvent) => {
    setSelect1(event.target.value as string);
  };

  // Defer SLP Modal State
  const [deferSLP, setDeferSLP] = React.useState(false);
  const handleDeferSLP = () => setDeferSLP(true);
  const handleDeferSLPClose = () => setDeferSLP(false);

  // Select2 State
  const [select2, setSelect2] = React.useState("17/11/2024");

  const handleSelect2Change = (event: SelectChangeEvent) => {
    setSelect2(event.target.value as string);
  };

  // Timeline Modal State
  const [sLPAudit, setSLPAudit] = React.useState(false);
  const handleSLPAudit = () => setSLPAudit(true);
  const handleSLPAuditClose = () => setSLPAudit(false);

  return (
    <div className="wrapper">
      <Box
        className="overlay"
        onClick={() => document.body.classList.toggle("sidebar-toggle")}
      />
      <DesignerHeader />
      <main>
        <DesignerSidebar />
        <div className="main-content">
          <Box className="content-header simple-header">
            <Typography variant="h2" className="heading">
              Student Profile Details
            </Typography>
            <Box sx={{ display: "flex", columnGap: "14px" }}>
              <Button
                variant="outlined"
                className="px-16"
                onClick={handleSLPAudit}
              >
                Audit Logs
              </Button>
              <Button
                variant="outlined"
                className="px-16"
                component={Link}
                to="/designer-slp-dashboard"
              >
                Back
              </Button>
            </Box>
          </Box>
          <Grid
            container
            spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
            className="content-container"
          >
            <Grid item xs={12}>
              <Card className="info-card">
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Student Details
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "10px",
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "#9E9E9E" }}>
                      SLP Participation
                    </Typography>
                    <Button className="btn-course px-8" variant="outlined">
                      <img
                        src={editPurpleIcon}
                        alt="Course List"
                        className="default"
                      />
                      <img
                        src={editWhiteIcon}
                        alt="Course List"
                        className="active"
                      />
                      <Typography variant="body2">Active</Typography>
                    </Button>
                  </Box>
                </Box>
                <Grid
                  container
                  spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
                >
                  {/* Line 1 */}
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Full Name
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Jacquelin Bellido
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Email
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Bellido
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Phone
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      233385457
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Date Of Birth
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      20/11/1998
                    </Typography>
                  </Grid>
                  {/* Line 2 */}
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Street Address
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Recovery & wellbeing
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Suburb
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Alfords Point
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      State
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      NEW
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Post Code
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      32504
                    </Typography>
                  </Grid>
                  {/* Line 3 */}
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Contact Method
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Email
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Emergency Contact Name
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Rachael Rogan
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Emergency Contact Relationship
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      Brother
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Emergency Contact Phone
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      826384427
                    </Typography>
                  </Grid>
                  {/* Line 4 */}
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Last SLP Completed
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      03 Aug 2023
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Next SLP Due Date
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      03 Nov 2023
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Next SLP Number
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      4
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} xl={3}>
                    <Typography variant="body1" className="sco-detail-title">
                      Number SLPs Currently Allocated
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      0
                    </Typography>
                  </Grid>
                  {/* Line 5 */}
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Number Completed SLPs
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      5
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className="sco-detail-title">
                      Supports Required/Specific Learning Needs
                    </Typography>
                    <Typography variant="body1" className="sco-detail">
                      -
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Contact Notes
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
                >
                  <Grid item xs={12}>
                    <TextField
                      label="Contact Note"
                      multiline
                      fullWidth
                      rows={3}
                      variant="outlined"
                      sx={{ mb: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Box className="btn-group">
                      <Button variant="contained" className="btn-save">
                        <img src={saveIcon} alt="save" />
                        Save
                      </Button>
                      <Button variant="outlined" className="btn-cancel">
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Next/Current SLP
                  </Typography>
                </Box>
                <TableContainer>
                  <Table className="table-h-md">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            maxWidth: "84px",
                            width: "84px",
                            minWidth: "84px",
                          }}
                        >
                          SLP Number
                        </TableCell>
                        <TableCell sx={{ width: "154px", minWidth: "154px" }}>
                          Due/Deferred Until
                        </TableCell>
                        <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                          Allocated To
                        </TableCell>
                        <TableCell
                          sx={{ width: "130px", minWidth: "130px" }}
                          align="center"
                        >
                          Contact Progress
                        </TableCell>
                        <TableCell align="center" sx={{ width: "92px" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row" align="center">
                          3
                        </TableCell>
                        <TableCell>17 Nov 2024</TableCell>
                        <TableCell>Alex Li</TableCell>
                        <TableCell align="center">
                          <Button
                            className="btn-progress not-started"
                            variant="outlined"
                          >
                            <img src={editYellowIcon} alt="Icon" />
                            <Typography variant="body2">Not Started</Typography>
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <div className="table-actions">
                            <IconButton onClick={handleReset}>
                              <img src={personEditIcon} alt="Edit" />
                            </IconButton>
                            <IconButton onClick={handleDeferSLP}>
                              <img src={calendarEditIcon} alt="Edit" />
                            </IconButton>
                            <IconButton
                              component={Link}
                              to="/designer-slp-goals"
                            >
                              <img src={listCheckIcon} alt="Edit" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row" align="center">
                          4
                        </TableCell>
                        <TableCell>10 Nov 2024</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell align="center">
                          <Button
                            className="btn-progress assigned"
                            variant="outlined"
                          >
                            <img src={editGreenIcon} alt="Icon" />
                            <Typography variant="body2">Assigned</Typography>
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <div className="table-actions">
                            <IconButton onClick={handleReset}>
                              <img src={personEditIcon} alt="Edit" />
                            </IconButton>
                            <IconButton onClick={handleDeferSLP}>
                              <img src={calendarEditIcon} alt="Edit" />
                            </IconButton>
                            <IconButton
                              component={Link}
                              to="/designer-slp-goals"
                            >
                              <img src={listCheckIcon} alt="Edit" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row" align="center">
                          5
                        </TableCell>
                        <TableCell>03 Nov 2024</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell align="center">
                          <Button
                            className="btn-progress in-progress"
                            variant="outlined"
                          >
                            <img src={editBlueIcon} alt="Icon" />
                            <Typography variant="body2">In Progress</Typography>
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <div className="table-actions">
                            <IconButton onClick={handleReset}>
                              <img src={personEditIcon} alt="Edit" />
                            </IconButton>
                            <IconButton onClick={handleDeferSLP}>
                              <img src={calendarEditIcon} alt="Edit" />
                            </IconButton>
                            <IconButton
                              component={Link}
                              to="/designer-slp-goals"
                            >
                              <img src={listCheckIcon} alt="Edit" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Box className="card-inner-head mb-24">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Completed SLPs
                  </Typography>
                </Box>
                <TableContainer>
                  <Table className="table-h-md">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            maxWidth: "84px",
                            width: "84px",
                            minWidth: "84px",
                          }}
                        >
                          SLP Number
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ width: "154px", minWidth: "154px" }}
                        >
                          Status
                        </TableCell>
                        <TableCell sx={{ width: "130px", minWidth: "130px" }}>
                          Completed By
                        </TableCell>
                        <TableCell sx={{ width: "200px", minWidth: "200px" }}>
                          Date Completed
                        </TableCell>
                        <TableCell align="center" sx={{ width: "92px" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row" align="center">
                          3
                        </TableCell>
                        <TableCell align="center" className="completed status">
                          <div>Completed</div>
                        </TableCell>
                        <TableCell>Rachael Rogan</TableCell>
                        <TableCell>10 Nov 2022 10:00 AM to 4:00 PM</TableCell>
                        <TableCell align="center">
                          <div className="table-actions">
                            <IconButton
                              component={Link}
                              to="/designer-view-slp-goals"
                            >
                              <img
                                src={courseListSecondaryIcon}
                                alt="View"
                                style={{ width: "17px", height: "17px" }}
                              />
                            </IconButton>
                            <IconButton
                              component={Link}
                              to="/designer-slp-goals"
                            >
                              <img src={editIcon} alt="Edit" />
                            </IconButton>
                            <IconButton>
                              <img src={deleteIcon} alt="Delete" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row" align="center">
                          4
                        </TableCell>
                        <TableCell align="center" className="completed status">
                          <div>Completed</div>
                        </TableCell>
                        <TableCell>Rachael Rogan</TableCell>
                        <TableCell>10 Nov 2022 10:00 AM to 4:00 PM</TableCell>
                        <TableCell align="center">
                          <div className="table-actions">
                            <IconButton
                              component={Link}
                              to="/designer-view-slp-goals"
                            >
                              <img
                                src={courseListSecondaryIcon}
                                alt="View"
                                style={{ width: "17px", height: "17px" }}
                              />
                            </IconButton>
                            <IconButton
                              component={Link}
                              to="/designer-slp-goals"
                            >
                              <img src={editIcon} alt="Edit" />
                            </IconButton>
                            <IconButton>
                              <img src={deleteIcon} alt="Delete" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Box className="table-card-header-new">
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    Enrolment and Attendance History
                  </Typography>
                  <Box>
                    <TextField
                      id="search"
                      variant="outlined"
                      className="search-input"
                      placeholder="Search"
                      size="small"
                      sx={{ mb: 0 }}
                    />
                  </Box>
                </Box>
                Table Here
              </Card>
            </Grid>
          </Grid>
          <DesignerFooter />
        </div>
      </main>

      {/* Allocate PLA Modal */}
      <Modal open={reset} onClose={handleResetClose}>
        <Box className="common-modal modal-400">
          <Box className="modal-header">
            <Typography variant="h4">Allocate PLA</Typography>
            <IconButton onClick={handleResetClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs={12}>
                <FormControl fullWidth className="select">
                  <InputLabel id="course1-label">Allocated To</InputLabel>
                  <Select
                    labelId="course1-label"
                    value={select1}
                    onChange={handleSelect1Change}
                  >
                    <MenuItem value="Alex Li">Alex Li</MenuItem>
                    <MenuItem value="Leslie Alexander">
                      Leslie Alexander
                    </MenuItem>
                    <MenuItem value="Arlene McCoy">Arlene McCoy</MenuItem>
                    <MenuItem value="Dianne Russell">Dianne Russell</MenuItem>
                    <MenuItem value="Jerome Bell">Jerome Bell</MenuItem>
                    <MenuItem value="Floyd Miles">Floyd Miles</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DesktopDatePicker"]}>
                    <DesktopDatePicker
                      className="date-picker"
                      label="Form Filling Date"
                      slotProps={{
                        textField: { fullWidth: true },
                      }}
                      slots={{
                        openPickerIcon: CalendarIcon,
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button
              variant="contained"
              className="btn-save"
              onClick={handleResetClose}
            >
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button
              variant="outlined"
              className="btn-cancel"
              onClick={handleResetClose}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Defer SLP Modal */}
      <Modal open={deferSLP} onClose={handleDeferSLPClose}>
        <Box className="common-modal modal-400">
          <Box className="modal-header">
            <Typography variant="h4">Defer SLP</Typography>
            <IconButton onClick={handleDeferSLPClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs>
                <FormControl fullWidth className="select">
                  <InputLabel id="course1-label">Due Date</InputLabel>
                  <Select
                    label="Status"
                    value={select2}
                    onChange={handleSelect2Change}
                  >
                    <MenuItem value="17/11/2024">17/11/2024</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button
              variant="contained"
              className="btn-save"
              onClick={handleDeferSLPClose}
            >
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button
              variant="outlined"
              className="btn-cancel"
              onClick={handleDeferSLPClose}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Timeline Modal */}
      <Modal open={sLPAudit} onClose={handleSLPAuditClose}>
        <Box className="common-modal modal-600 timeline-modal">
          <Box className="modal-header">
            <Typography variant="h4">
              SLP Audit Trail - Jacquelin Bellido
            </Typography>
            <IconButton onClick={handleSLPAuditClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <div className="timeline">
              {timelineData.map((item) => (
                <div className="timeline-item" key={item.id}>
                  <span className="timeline-marker" />
                  <div className="timeline-content">
                    <Typography variant="h5" className="timeline-title">
                      {item.title}
                      <span className="timeline-meta">- By {item.author}</span>
                    </Typography>
                    <Typography variant="body2" className="timeline-text">
                      {item.description}
                    </Typography>
                    <Typography variant="body2" className="text-gray">
                      {item.date}
                    </Typography>
                  </div>
                </div>
              ))}
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default DesignerStudentProfileDetails;
